import React from "react";
import { FeatureArticleProductListItem } from "web/react/components/feature-article/types";
import { KeylineGrid, KeylineGridItem } from "web/react/components/keyline-grid";
import ProductCard from "web/react/components/product-card/react/product-card";
import { HStack } from "web/react/emo/h-stack";
import {
    ProductCardDetails,
    ProductCardPrice,
    ProductCardWishlist,
    ProductImage,
} from "web/react/emo/product-card";
import { VStack } from "web/react/emo/v-stack";

interface FeatureArticleProductListProps {
    items: FeatureArticleProductListItem[];
    isSponsored?: boolean;
}

/** A responsive grid of Catalog-enriched product cards (unresolved products are skipped). */
export function FeatureArticleProductList({
    items,
    isSponsored = false,
}: FeatureArticleProductListProps): React.ReactElement | null {
    if (!items.some((item) => item.product)) {
        return null;
    }

    return (
        <KeylineGrid>
            {items.map((item, index) =>
                item.product ? (
                    <KeylineGridItem key={`${item.buy_option_id}-${index}`}>
                        <ProductCard product={item.product}>
                            <VStack spacing="sm">
                                <ProductImage shouldRenderLeadLinkInImage={isSponsored} />
                                <VStack spacing="xxs">
                                    <HStack justify="space-between">
                                        <ProductCardPrice size="lg" />
                                        <ProductCardWishlist
                                            isSavedForLater={item.product.is_saved_for_later}
                                        />
                                    </HStack>
                                    <ProductCardDetails shouldRenderLeadLink={isSponsored} />
                                </VStack>
                            </VStack>
                        </ProductCard>
                    </KeylineGridItem>
                ) : null
            )}
        </KeylineGrid>
    );
}
